import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCLP(amount: number): string {
  return amount.toLocaleString('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
}

export function parseCLPToNumber(value: string): number {
  // Elimina el símbolo de peso, puntos y cualquier otro carácter que no sea número
  const numericValue = value.replace(/[$.]/g, '').trim();
  return numericValue ? parseInt(numericValue, 10) : 0;
}
